// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"d11a7c76","893":"c2d19519"}[chunkId] + ".chunk.css";
};